import * as React from "react";
import { Popover as MantinePopover } from "@mantine/core";
import styled, { css, useTheme } from "styled-components";
import { borderColor } from "theme/utils/borderStyles";
const Popover = ({ ...props }) => {
  const theme = useTheme();
  const arrowBackground = !props.position || props.position.startsWith("bottom") ? theme.colors.variant.lightest.default : theme.colors.global.contentBackground;
  const styles = () => ({
    dropdown: {
      backgroundColor: theme.colors.global.contentBackground,
      ...borderColor(theme.colors.variant.light.default),
      padding: 0
    },
    arrow: {
      ...borderColor(theme.colors.variant.light.default),
      backgroundColor: arrowBackground
    }
  });
  return /* @__PURE__ */ React.createElement(MantinePopover, { styles, zIndex: 1060, ...props });
};
const Children = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacings.sm} ${theme.spacings.md};
  `
);
const Title = styled.h4(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.lightest.default};
    color: ${theme.colors.variant.darkest.default};
    padding: ${theme.spacings.sm} ${theme.spacings.md};
    font-size: ${theme.fonts.size.body};
  `
);
const titleId = (id) => `${id}-title`;
const dropdownAriaLabelledby = (ariaLabelBy, id, title) => {
  if (ariaLabelBy) {
    return ariaLabelBy;
  }
  if (id && title) {
    return titleId(id);
  }
  return null;
};
const Dropdown = ({ title = void 0, children, ...rest }) => /* @__PURE__ */ React.createElement(MantinePopover.Dropdown, { "aria-labelledby": dropdownAriaLabelledby(rest["aria-labelledby"], rest.id, title), ...rest }, title && /* @__PURE__ */ React.createElement(Title, { id: rest.id ? titleId(rest.id) : null }, title), /* @__PURE__ */ React.createElement(Children, null, children));
Popover.Target = MantinePopover.Target;
Popover.Dropdown = Dropdown;
export default Popover;
